var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "act-liveness-root",
      class: { "ar-style": _vm.$i18n.locale === "ar" },
    },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `padding-top:${_vm.barHeight}px`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: "", "left-arrow": "" },
            on: { "click-left": _vm.goPrevious },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow02.png"),
                        alt: "",
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c("div", { staticClass: "top-bg" }),
      _c("div", { staticClass: "liveness-tit" }, [
        _vm._v(_vm._s(_vm.$t("lang.commonM.k127"))),
      ]),
      _c("div", { staticClass: "liveness-content" }, [
        _c("div", { staticClass: "top-con" }, [
          _vm._v(_vm._s(_vm.$t("lang.commonM.k128"))),
        ]),
        _c("div", { staticClass: "bottom-con" }, [
          _c("p", { staticClass: "bottom-tit" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k129"))),
          ]),
          _c("p", { staticClass: "bottom-txt" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k130"))),
          ]),
          _c("p", { staticClass: "bottom-tit" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k131"))),
          ]),
          _c("ul", { staticClass: "bottom-txt" }, [
            _c("li", [_vm._v(_vm._s(_vm.$t("lang.commonM.k132")))]),
            _c("li", [
              _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k133")) + " "),
              _c("i", [_vm._v(_vm._s(_vm.$t("lang.commonM.k134")))]),
              _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k135")) + " "),
            ]),
            _c("li", [_vm._v(_vm._s(_vm.$t("lang.commonM.k136")))]),
            _c("li", [_vm._v(_vm._s(_vm.$t("lang.commonM.k137")))]),
          ]),
          _c("p", { staticClass: "bottom-tit" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k138"))),
          ]),
          _c("p", { staticClass: "bottom-txt" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k139"))),
          ]),
          _c("p", { staticClass: "bottom-tit" }, [
            _vm._v(_vm._s(_vm.$t("lang.commonM.k140"))),
          ]),
          _c("p", { staticClass: "bottom-txt" }, [
            _c("i", [_vm._v(_vm._s(_vm.$t("lang.commonM.k141")))]),
            _vm._v(" " + _vm._s(_vm.$t("lang.commonM.k142")) + " "),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }